import { axiosInstance } from "@src/api/axiosConfig";
import { useQuery } from "react-query";

const nestPath = process.env.REACT_APP_NEST_API_URL;

const AgencyKey = {
    useGetMatchProgress: "AgencyKey.query.useGetMatchProgress",
    useGetMatchProgressTakers: "AgencyKey.query.useGetMatchProgressTakers",
};

export type matchStatusType =
    | "wait_experts" // 전문가 지원 대기
    | "in_consuting" // 매물컨설팅 진행 중
    | "complete_consuting" // 매물컨설팅 완료
    | "before_auction_agent" // 매수신청대리 시작 전
    | "in_auction_agent" // 매수신청대리 진행 중
    | "complete_auction_agent" // 매수신청대리 완료
    | "wait_settlement" // 정산 대기
    | "complete_settlement" // 정산 완료 (매칭 종료)
    | "closed"; // 정산 완료

export interface getMatchProgressRequest {
    serviceType?: string;
    matchStatus?: string;
    searchType?: string;
    searchValue?: string;
    page: number;
    limit: number;
}

export interface getMatchProgressResponse {
    matches: {
        matchNo: number;
        serviceType:
            | 1 // 매물컨설팅+매수신청대리 (경매대행)
            | 2 // 매수신청대리
            | 3; // 매물컨설팅
        matchStatus: matchStatusType;
        matchUserName: string;
        matchUserNo: number;
        takerUserName: string;
        matchTakerUserNo: number;
        alarmReceivedCount: number;
        openMatchInfoCount: number;
        requestedCount: number;
        startDate: string;
        endDate: string;
    }[];
    totalCount: number;
    monthlyCount: number;
    page: number;
    limit: number;
    cursor: string;
}

export const getMatchProgress = async (params: getMatchProgressRequest): Promise<getMatchProgressResponse> => {
    const { data } = await axiosInstance.get(`${nestPath}/match/progress`, { params });
    return data;
};

export const useGetMatchProgress = (params: getMatchProgressRequest, enabled: boolean = false) => {
    return useQuery([AgencyKey.useGetMatchProgress, params], () => getMatchProgress(params), {
        enabled,
    });
};

export interface getMatchProgressTakersRequest {
    matchNo: number;
    takerType:
        | "request" // 지원한 전문가
        | "push" // 알람 받은 전문가
        | "view"; // 의뢰열람
    page: number;
    limit: number;
}

export interface getMatchProgressTakersResponse {
    serviceType?:
        | 1 // 매물컨설팅+매수신청대리 (경매대행)
        | 2 // 매수신청대리
        | 3; // 매물컨설팅
    matchUserName: string;
    experts: {
        matchRequestStatus: number;
        takerUserNo: number;
        takerEmail: string;
        takerUserName: string;
        takerPhone: string;
        counselingCategories: string[];
    }[];
    totalCount: number;
    page: number;
    limit: number;
    cursor: string;
}

export const getMatchProgressTakers = async (
    params: getMatchProgressTakersRequest,
): Promise<getMatchProgressTakersResponse> => {
    const { data } = await axiosInstance.get(`${nestPath}/match/progress/takers`, { params });
    return data;
};

export const useGetMatchProgressTakers = (params: getMatchProgressTakersRequest, enabled: boolean = false) => {
    return useQuery([AgencyKey.useGetMatchProgressTakers, params], () => getMatchProgressTakers(params), {
        enabled,
    });
};
